var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z",
    fill: "#B0B5BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1443 11.7367C5.1443 11.7367 11.0885 9.20786 13.15 8.31739C13.9403 7.96123 16.6203 6.82142 16.6203 6.82142C16.6203 6.82142 17.8573 6.3228 17.7542 7.53379C17.7198 8.03246 17.445 9.77771 17.1701 11.6655C16.7578 14.3369 16.3111 17.2575 16.3111 17.2575C16.3111 17.2575 16.2424 18.0767 15.6583 18.2192C15.0742 18.3617 14.1121 17.7206 13.9403 17.5781C13.8028 17.4713 11.3633 15.8684 10.47 15.0848C10.2295 14.8711 9.95462 14.4437 10.5043 13.9451C11.7413 12.7697 13.2187 11.3093 14.1121 10.3833C14.5244 9.95582 14.9367 8.95852 13.2187 10.1695C10.7792 11.9148 8.37408 13.5533 8.37408 13.5533C8.37408 13.5533 7.82432 13.9094 6.79355 13.5888C5.76273 13.2683 4.56015 12.8409 4.56015 12.8409C4.56015 12.8409 3.73557 12.3066 5.1443 11.7367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg-icon.966973537cb16bcf319b51bb1aea4487.svg";
export { ForwardRef as ReactComponent };